import React from 'react';

import { FormControlLabel, Grid, Switch } from '@mui/material';

import { SxProp } from 'src/types/mui';

import type { SwitchFieldProps } from './interface';

const SwitchField: React.FC<SwitchFieldProps> = ({
  label = '',
  input,
  formControlLabelProps = {},
  leftLabel = '',
  rightLabel = '',
  ...rest
}) => {
  const { name, value, onBlur, onChange } = input;

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.checked);
    },
    [onChange],
  );

  if (leftLabel && rightLabel) {
    return (
      <Grid component="label" container alignItems="center" spacing={1} maxWidth="max-content">
        <Grid sx={labelStyles}>{leftLabel}</Grid>
        <Grid>
          <Switch name={name} checked={value} onChange={handleChange} onBlur={onBlur} {...rest} />
        </Grid>
        <Grid sx={labelStyles}>{rightLabel}</Grid>
      </Grid>
    );
  }

  return (
    <FormControlLabel
      {...formControlLabelProps}
      label={label}
      control={
        <Switch name={name} checked={value} onChange={handleChange} onBlur={onBlur} {...rest} />
      }
    />
  );
};

const labelStyles: SxProp = {
  cursor: 'pointer',
};

export { SwitchField };
